import React, { useEffect, useState } from "react";
import searchIcon from "../../../asset/images/search-icon.svg";
import downloadbrokrage from "../../../asset/images/download-brokrage.svg";
import {
  AESEncryption,
  ApiResDecrypt,
  formatDate,
  noDataFound,
  onlyNumber,
} from "../../../CommonMethhods/CommonMethods";
import { Constants } from "../../../CommonMethhods/Constants";
import editBtn from "../../../asset/images/edit-underline.svg";
import eyeIcon from "../../../asset/images/eyeIcon.svg";
import deleteIcon from "../../../asset/images/delete-red.svg";
import { Lead_Creation } from "../../../Configuration/API_URL";
import { toast } from "react-toastify";
import { useRef } from "react";
import Loader from "../../../Components/Common/Loader";
import { useDebounce } from "../../../Components/useDebounce";
import SmallLoader from "../../../Components/Common/smallLoader";
import { useClientContext } from "../../../context/ClientContext";
import { Modal } from "react-bootstrap";
import questionImg from "../../../asset/images/questionIcon.svg";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function OverviewTable({activeTab}) {
  const storeToken = localStorage.getItem("ssoToken");
  const [individualData, setIndividualData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [errorResp, setErrorResp] = useState("");
  const [offset, setOffset] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [searchField, setSerchField] = useState(false);
  const [fromDateErr, setFromDateErr] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("")
  const [loadingRow, setLoadingRow] = useState({ mobile: null, type: null });
  const [toDateErr, setToDateErr] = useState("");
  const [isSearchEnabled, setIsSearchEnabled] = useState(false);
  const [delModal, setDelModal] = useState(false);
  const [delData, setDelData] = useState("");
  const [delLoader, setDelLoader] = useState(false);
  const { setSelectedClient, setShouldPrefill} = useClientContext();

  const debouncedValue = useDebounce(searchInput, 1000);

  useEffect(() => {
    handleSearchChange(debouncedValue);
  }, [debouncedValue]);

  const todatRef = useRef("");
  const typeRef = useRef("");
  const fromDateRef = useRef("");

  const downloadData = async (data, type) => {
    setLoadingRow({ mobile: data.mobile, type });

    let payloadValue = { mobileNo: data?.mobile};
    let encPayload = AESEncryption(payloadValue);
    console.log(payloadValue, "payloadValue");
    try {
      const deleteData = await axiosInstance.post(
        Lead_Creation.view_Lead_Table,

        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(deleteData?.data);

      if (res?.status === 0) {
        if(type === "preview"){
          setPreviewUrl(res?.data)
          setShowModal(true)
        }else{
        window.open(res?.data, "_blank", "noopener,noreferrer")
        }
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingRow({ mobile: null, type: null });
    }
  };

  const handleSearchChange = (data) => {
    if (data) {
      overviewDetails(data, "grid", 5);
    } else if (searchField === true) {
      overviewDetails("", "grid", 5);
    }
    setOffset(0);
  };

  const overviewDetails = async (value = "", type, limit) => {
    if (type == "excel") {
      setSmallLoaderExcel(true);
      setLoader(false);
    } else {
      setLoader(true);
      setSmallLoaderExcel(false);
    }

    let payloadValue = {
      fromDate: fromDateRef.current.value,
      toDate: todatRef.current.value,
      search: value,
      fileType: type,
      offset: type == "excel" ? -1 : offset,
      limit: limit,
    };

    console.log(payloadValue, "payloadValue");
    let encPayload = AESEncryption(payloadValue);

    try {
      const getOtp = await axiosInstance.post(
        Lead_Creation.GetOver_Individual_Data,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getOtp?.data);
      console.log(res, "res0000");
      if (res?.status === 0) {
        if(type === "grid"){
        setIndividualData(res?.data?.individualAccounts);
        }
        else if(type === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer")
        }
      } else {
        setIndividualData([]);
        if (type === "excel") {
          toast.error(res?.message);
        }else{
          setErrorResp(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
      setSmallLoaderExcel(false);
    }
  };


  useEffect(() => {
    if (activeTab === "overview") {
    overviewDetails(searchInput, "grid", 5);
    }
  }, [offset, activeTab]);

  const handleFileType = () => {
    overviewDetails(searchInput, "excel", 1);
  };

  const deleteOverviewData = async (data) => {
  setDelLoader(true);
    let payloadValue = { mobile: data };
    let encPayload = AESEncryption(payloadValue);
    console.log(payloadValue, "payloadValue");
    try {
      const deleteData = await axiosInstance.post(
        Lead_Creation.Delete_Overview_List,

        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(deleteData?.data);

      if (res?.status === 0) {
        setDelModal(false)
        overviewDetails(searchInput, "grid", 5);
        toast.success(res?.data);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setDelLoader(false);
    }
  };

  const handleDeleteBtn = (data) => {
    setDelData(data)
    setDelModal(true)
    
  };
  const handleClientClick = (client) => {
    setSelectedClient(client);
    setShouldPrefill(true);
    if (client?.type?.toLowerCase() === "individual") {
      document.getElementById("rejection-tab")?.click();
    } else {
      document.getElementById("deletedash-tab")?.click();
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const fromDate = fromDateRef.current.value;
    const toDate = todatRef.current.value;

    let hasError = false;
    setFromDateErr("");
    setToDateErr("");
    setErrorResp("");

    if (!fromDate) {
      setFromDateErr("From Date is required");
      hasError = true;
    }

    if (!toDate) {
      setToDateErr("To Date is required");
      hasError = true;
    }

    if (hasError) return;

    if (typeRef.current.value !== "") {
      setLoader(true);
      overviewDetails(searchInput, "grid", 5);
    }

  setIsSearchEnabled(false);
  };

  const handleDateChange = () => {
    const from = fromDateRef.current.value;
    const to = todatRef.current.value;
    if (from) setFromDateErr("");
    if (to) setToDateErr("");
    if (from && to && new Date(from) > new Date(to)) {
      setFromDateErr("From Date should be less than To Date");
      setIsSearchEnabled(false);
    } else if (from && to) {
    setFromDateErr("");
    setIsSearchEnabled(true);
  } else {
    setIsSearchEnabled(false);
  }
  };

  const handleDownload =(data, type) => {    
    downloadData(data, type)
  }

  const handlePasteSearch = (e) => {
  e.preventDefault();
  const pastedText = e.clipboardData.getData("text");
  let clean = pastedText
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, "")     
    .replace(/\s{2,}/g, " ")        
    .replace(/^\s+/, "")         
    .replace(/\s+$/, "")             
    .slice(0, 50);

  if (clean === "") return;
  const input = e.target;
  const start = input.selectionStart;
  const end = input.selectionEnd;
  const currentValue = input.value;
  const newValue = (
    currentValue.slice(0, start) +
    clean +
    currentValue.slice(end)
  ).slice(0, 50);

  setSearchInput(newValue); // Update state
  setSerchField(true);
  input.value = newValue;

  const cursorPos = Math.min(start + clean.length, 50);
  setTimeout(() => input.setSelectionRange(cursorPos, cursorPos), 0);
};

const handleCloseModal = () => {
    setDelData("")
    setDelModal(false)
  }

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  return (
    <>
    <div className="personal-page brokerage">
      <form
        className="date-form ap-payout-wrapper wrap-button"
        onSubmit={(e) => onSubmit(e)}
      >
        <div className="row input-field-wrapper">
          <div className="col-md-3 col-sm-6 col-6">
            <div className="form-group">
              <label className="form-label">{Constants.From_Date}</label>
              <input
                type="date"
                // placeholder="DD-MM-YYYY"
                className="datepicker form-control text-uppercase"
                id="FromDateApPayout"
                ref={fromDateRef}
                max={DateReverse}
                onChange={handleDateChange}
              />
              {fromDateErr && (
                <p className="forget-link add-error">
                  <span>{fromDateErr}</span>
                </p>
              )}
            </div>
          </div>
          <div className="col-md-3 col-sm-6 col-6">
            <div className="form-group">
              <label className="form-label">{Constants.To_Date}</label>
              <input
                type="date"
                ref={todatRef}
                className="datepicker form-control text-uppercase"
                max={DateReverse}
                id="ToDateApPayout"
                onChange={handleDateChange}
              />
              {toDateErr && (
                <p className="forget-link add-error">
                  <span>{toDateErr}</span>
                </p>
              )}
            </div>
          </div>
        </div>

        <button 
          value="grid" 
          type="submit"
          className={`margin-save-btn ${!isSearchEnabled ? "disable-btn" : ""}`}
          disabled={!isSearchEnabled}>
          {Constants.Search}
        </button>
      </form>

      {/* {individualData && individualData?.length > 0 && ( */}
        <div className="personal-wrapper">
          <div className="search-input-wrapper">
            <div className="rm-custom-dropdown">
              <img src={searchIcon} alt="search" />

              <input
                type="text"
                name="search-text"
                className="input-st ap"
                value={searchInput}
                // maxLength={6}
                placeholder="Search here"
                autoComplete="off"
                onChange={(e) => {
                  let input = e.target.value
                  input = input
                  .toLowerCase()
                    .replace(/[^a-z0-9\s]/g, "")
                    .replace(/\s+/g, " ")
                    .trimStart();
                  if (input.length > 50) input = input.slice(0, 50);

                  setSearchInput(input);
                  setSerchField(true);
                }}
                // onChange={handleInputChange}
                 onPaste={handlePasteSearch}
              />
              
            </div>
            { individualData && individualData?.length > 0 && (

            <button
              className="dnload-btn"
              // value="excel"
              onClick={handleFileType}
            >
              {smallLoaderExcel ? (
                <SmallLoader />
              ) : (
                <>
                  <img src={downloadbrokrage} alt="download" />
                  Download All
                </>
              )}
            </button>
            )}
          </div>
        </div>
      {/* )} */}
      <div className="brokerage-table">
        {loader ? (
          <div className="loader-alignment">
            <Loader />
          </div>
        ) : (
          <div className="scroll-table overview-table">
            {individualData && individualData?.length > 0 ? (
              <table className="table">
                <thead>
                  <tr>
                    <th style={{ width: "80px" }}>
                      <span className="wrap-th">
                        <span>Sr. No</span>
                      </span>
                    </th>
                    <th style={{ width: "140px" }}>
                      <span className="wrap-th">
                        <span>Client Name</span>
                        <span className="wrap-icons">
                          <span
                            className="icon-up-triangle"
                            //   onClick={() => descendingOrder("rmCode")}
                          ></span>
                          <span
                            className="icon-down-triangle"
                            //   onClick={() => ascendingOrder("rmCode")}
                          ></span>
                        </span>
                      </span>
                    </th>
                    <th style={{ width: "140px" }}>
                      <span className="wrap-th">
                        <span>Mobile Number</span>
                        <span className="wrap-icons">
                          <span
                            className="icon-up-triangle"
                            // onClick={() => descendingOrder("rmName")}
                          ></span>
                          <span
                            className="icon-down-triangle"
                            //   onClick={() => ascendingOrder("rmName")}
                          ></span>
                        </span>
                      </span>
                    </th>
                    <th style={{ width: "140px" }}>
                      <span className="wrap-th">
                        <span>Type</span>
                        <span className="wrap-icons">
                          <span
                            className="icon-up-triangle"
                            //   onClick={() => descendingOrder("delivery")}
                          ></span>
                          <span
                            className="icon-down-triangle"
                            //   onClick={() => ascendingOrder("delivery")}
                          ></span>
                        </span>
                      </span>
                    </th>
                    <th style={{ width: "140px" }}>
                      <span className="wrap-th">
                        <span>Status</span>
                        <span className="wrap-icons">
                          <span
                            className="icon-up-triangle"
                            //   onClick={() => descendingOrder("intraday")}
                          ></span>
                          <span
                            className="icon-down-triangle"
                            //   onClick={() => ascendingOrder("intraday")}
                          ></span>
                        </span>
                      </span>
                    </th>
                    <th style={{ width: "140px" }}>
                      <span className="wrap-th">
                        <span>Created Date</span>
                        <span className="wrap-icons">
                          <span
                            className="icon-up-triangle"
                            //   onClick={() => descendingOrder("futures")}
                          ></span>
                          <span
                            className="icon-down-triangle"
                            //   onClick={() => ascendingOrder("futures")}
                          ></span>
                        </span>
                      </span>
                    </th>
                    <th>
                      <span className="wrap-th">
                        <span>Actions</span>
                        <span className="wrap-icons">
                          <span
                            className="icon-up-triangle"
                            //   onClick={() => descendingOrder("futures")}
                          ></span>
                          <span
                            className="icon-down-triangle"
                            //   onClick={() => ascendingOrder("futures")}
                          ></span>
                        </span>
                      </span>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {individualData?.length > 0 &&
                    individualData.map((data, index) => {
                      const status = data?.status?.toLowerCase();
                      const isIncomplete = status === "pending";
                  const isSubmitted = status === "submitted";
                  const isAccountOpened = status === "completed";
                  const isRejected = status === "rejected";

                  return(
                      <tr key={index}>
                        <td style={{ width: "80px" }}>{index + 1}</td>
                        <td
                          style={{
                            width: "140px",
                            cursor: !isSubmitted && !isAccountOpened ? "pointer" : "default",
                            color: !isSubmitted && !isAccountOpened ? "#1c74d3" : "#000",
                          }}
                          onClick={() => {
                            if (!isSubmitted && !isAccountOpened) {
                                handleClientClick(data);
                              }}
                            }
                        >
                          {data?.clientName}
                        </td>
                        <td style={{ width: "140px" }}>{data?.mobile}</td>
                        <td style={{ width: "140px" }}>{data?.type}</td>
                        <td style={{ width: "140px" }}>{data?.status}</td>
                        <td style={{ width: "140px" }}>
                          {formatDate(data?.createdDt)}
                        </td>
                        <td>
                          <div className="last-td">
                            <button
                              className="btn-overview"
                              onClick={() => handleClientClick(data)}
                              disabled={isSubmitted || isAccountOpened}
                              // disabled={data?.status?.toLowerCase() === "submitted" || "completed"}
                            >
                              <img src={editBtn} alt="edit" />
                              <span>Edit</span>
                            </button>

                            <button type="button"
                              className="btn-overview table-btns" 
                              onClick={()=> handleDownload(data, "download")}
                              // disabled={data?.status?.toLowerCase() === "pending" || "rejected"}
                              disabled={isIncomplete || isRejected}
                              >
                                {loadingRow?.mobile === data?.mobile && loadingRow?.type === "download" ? (
                                  <SmallLoader />
                                ) : (
                                  <>
                                    <img src={downloadbrokrage} alt="download" />
                                    <span>Download</span>
                                  </>
                                )}
                            </button>
                            <button
                              className="btn-overview btn-preview"
                              onClick={() => handleDownload(data, "preview")}
                              // disabled={data?.status?.toLowerCase() === "pending" || "rejected"}
                              disabled={isIncomplete || isRejected}
                            >
                              {loadingRow?.mobile === data?.mobile && loadingRow?.type === "preview" ? (
                                <SmallLoader />
                              ) : (
                                <>
                                  <img src={eyeIcon} alt="eye" />
                                  <span>Preview</span>
                                </>
                              )}
                            </button>
                            <button
                              className="del-btn-overview"
                              onClick={() => handleDeleteBtn(data?.mobile)}
                              disabled={isSubmitted || isAccountOpened}
                              // disabled={data?.status?.toLowerCase() === "completed" || "completed"}
                            >
                              <img src={deleteIcon} alt="delete" />
                              <span>Delete</span>
                            </button>
                          </div>
                        </td>
                      </tr>
                  )
                    })}
                </tbody>
              </table>
            ) : (
              noDataFound(errorResp)
            )}
          </div>
        )}
      </div>
    </div>

    <Modal
            show={delModal}
            onHide={handleCloseModal}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="setting-model ifsc-Modal bank-verify-modal individual-modal final-modal"
            backdrop="static"
            keyboard={false}
          >
            <button
              type="button"
              className="btn-close ifsc-modal-btn"
              aria-label="Close"
              onClick={handleCloseModal}
            >
              <span className="icon-close"></span>
            </button>
            <Modal.Header className="modal-header ifsc-modal-header">
              <Modal.Title id="contained-modal-title-vcenter modal-title">
                <span>
                  <img src={questionImg} alt="questionIcon" />
                </span>
                <p className="final-modal-title">Are you sure you want to delete the details?</p>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="nominee-btn-wrapper nominee-wrap-sec nom-btns">
                <div
                className="wrap-button"
                 
              >
                <button
                  type="button"
                  className="val-btn-nom cancel-btn"
                  onClick={handleCloseModal}
                 
                >
                  Cancel
                </button>
                </div>
                <div className="wrap-button">
                  
                
                  <button type="submit" className="val-btn-wrap"
                    onClick={() => {!delLoader && deleteOverviewData(delData)}}>
                      {delLoader ? 
                  <SmallLoader />
                  :
                    <>Yes</>
                      }
                  </button>
                
                </div>
              </div>
            </Modal.Body>
          </Modal>

    <Modal
        show={showModal}
        onHide={() =>setShowModal(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inactive-modal preview-model"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <div className="figure-inlac">
            </div>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() =>setShowModal(false)}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive scroll-table model-top-active-table">
            <iframe
                  src={previewUrl}
                  title="pdf show"
                  frameBorder="0"
                  allowFullScreen="allowfullscreen"
                  style={{ border: "0" }}
                ></iframe>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default OverviewTable;
